// Aggregation Filtering Types for filtering signal.
export enum AGGREGATION_TYPES {
  TYPE = 'type',
  SOURCE = 'source'
}

// URI key
export const URI: string = 'uri';

/**
 * Relates to types in the search fields.
 *
 * Note: Used to fetch search fields of that
 * relates to specific types.
 *
 * Search fields created from insights are marked as insights
 * Search fields created from signals feed are marked as signals-feed
 */
export enum SearchFieldsRelatesTo {
  INSIGHTS = 'insights',
  SIGNALS_FEED = 'signals-feed'
}
